module.exports = __webpack_public_path__ + "img/train-intro3.36cbcb37.jpg";